export const countryOptions = [
  { key: "en", value: "en-US", flag: "us", text: "USA" },
  { key: "fr", value: "fr-FR", flag: "fr", text: "France" },
  { key: "es", value: "es-ES", flag: "es", text: "Spain" }
];

export const tvOptions = [
  { key: "1", value: "popular", text: "Get the Most Popular Tv Show" },
  { key: "2", value: "top_rated", text: "Get the Top-Rated Tv Show" }
];



// WEBPACK FOOTER //
// ./src/utils/optionsData.js